import { Box, Grid, makeStyles } from '@material-ui/core';
import Tooltip from '@material-ui/core/Tooltip';
import {
  formStyle,
  StyledCaption,
  StyledGridLeft,
  StyledPaper,
  StyledShortBody,
} from 'components/AccordionDetail/style';
import { isReverse } from 'helpers/intl';
import React from 'react';
import { Info } from 'react-feather';
import { injectIntl, IntlShape } from 'react-intl';
import { useSelector } from 'react-redux';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { currencyFormat, renderUnit } from 'utils/string';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles({
  ...formStyle,
});

interface AccordionDetailType {
  intl: IntlShape;
  subTitle: string;
  subTitleDescription: string;
  valueDh: number;
  secondSubTitle?: string;
  secondsubTitleDescription?: string;
  secondvalueDh?: string;
  thirdSubTitle?: string;
  thirdsubTitleDescription?: string;
  thirdvalueDh?: number;
  fullWidth?: boolean;
  handleOpenTooltipDialog?: Function;
}

const AccordionDetail = ({
  valueDh,
  subTitle,
  subTitleDescription,
  secondSubTitle,
  secondsubTitleDescription,
  secondvalueDh,
  thirdSubTitle,
  thirdsubTitleDescription,
  thirdvalueDh,
  fullWidth,
  handleOpenTooltipDialog,
  ...props
}: AccordionDetailType) => {
  const lang = useSelector(getLocaleSelector);
  const reverse = isReverse(lang);
  const classes = useStyles();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <StyledPaper>
            <Box width="100%">
              <Grid container spacing={3}>
                <Grid item xs={12} sm={fullWidth ? 12 : 4}>
                  <Grid item>
                    <Grid container spacing={1}>
                      <Grid item>
                        <StyledCaption>{subTitle}</StyledCaption>
                      </Grid>
                      <StyledGridLeft item xs={1}>
                        <Tooltip
                          title={matches ? '' : subTitleDescription}
                          onClick={
                            handleOpenTooltipDialog &&
                            handleOpenTooltipDialog(
                              subTitle,
                              subTitleDescription,
                            )
                          }
                        >
                          <Info
                            className={classes.infoIcon}
                            fontSize={'small'}
                          />
                        </Tooltip>
                      </StyledGridLeft>
                    </Grid>
                  </Grid>

                  <Grid item dir="ltr">
                    <Box marginBottom={0}>
                      <StyledShortBody reverse={reverse}>
                        {currencyFormat(valueDh) +
                          '' +
                          renderUnit(valueDh, reverse)}
                      </StyledShortBody>
                    </Box>
                  </Grid>
                </Grid>
                {secondvalueDh && secondSubTitle && secondsubTitleDescription && (
                  <Grid item xs={12} sm={fullWidth ? 12 : 4}>
                    <Grid item>
                      <Grid container spacing={1}>
                        <Grid item>
                          <StyledCaption>{secondSubTitle}</StyledCaption>
                        </Grid>
                        <StyledGridLeft item xs={1}>
                          <Tooltip
                            title={matches ? '' : secondsubTitleDescription}
                            onClick={
                              handleOpenTooltipDialog &&
                              handleOpenTooltipDialog(
                                secondSubTitle,
                                secondsubTitleDescription,
                              )
                            }
                          >
                            <Info
                              className={classes.infoIcon}
                              fontSize={'small'}
                            />
                          </Tooltip>
                        </StyledGridLeft>
                      </Grid>
                    </Grid>

                    <Grid item dir="ltr">
                      <Box marginBottom={0}>
                        <StyledShortBody reverse={reverse}>
                          {secondvalueDh}
                        </StyledShortBody>
                      </Box>
                    </Grid>
                  </Grid>
                )}
                {thirdsubTitleDescription && thirdSubTitle && (
                  <Grid item xs={12} sm={fullWidth ? 12 : 4}>
                    <Grid item>
                      <Grid container spacing={1}>
                        <Grid item>
                          <StyledCaption>{thirdSubTitle}</StyledCaption>
                        </Grid>
                        <StyledGridLeft item xs={1}>
                          <Tooltip
                            title={matches ? '' : thirdsubTitleDescription}
                            onClick={
                              handleOpenTooltipDialog &&
                              handleOpenTooltipDialog(
                                thirdSubTitle,
                                thirdsubTitleDescription,
                              )
                            }
                          >
                            <Info
                              className={classes.infoIcon}
                              fontSize={'small'}
                            />
                          </Tooltip>
                        </StyledGridLeft>
                      </Grid>
                    </Grid>

                    <Grid item dir="ltr">
                      <Box marginBottom={0}>
                        {thirdvalueDh ? (
                          <StyledShortBody reverse={reverse}>
                            {currencyFormat(thirdvalueDh) +
                              '' +
                              renderUnit(thirdvalueDh, reverse)}
                          </StyledShortBody>
                        ) : (
                          <StyledShortBody reverse={reverse}>
                            {'-'}
                          </StyledShortBody>
                        )}
                      </Box>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Box>
          </StyledPaper>
        </Grid>
      </Grid>
    </>
  );
};

export default injectIntl(AccordionDetail);
